import { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';
import { ErpIntermediateMetadataSchema } from '@vy/types';
import {
  InvoiceNumberSyncStrategySchema,
  InvoicePaymentStatusSyncStrategySchema,
  TAX_EXPORT_STRATEGY,
  TaxExportStrategySchema,
} from '@vy/integrations-types';

export const NetSuiteConfigurationFormSchema = oz.object({
  defaultReceivableAccount: oz.string().optional(),
  defaultProduct: ErpIntermediateMetadataSchema.omit({
    integrationSource: true,
  })
    .nullable()
    .optional(),
  taxExportStrategy: TaxExportStrategySchema.default(TAX_EXPORT_STRATEGY.INCLUDE_IN_AMOUNT),
  accountTaxItem: ErpIntermediateMetadataSchema.omit({ integrationSource: true }).nullable().optional(),
  taxItemBySubsidiaryId: oz.record(
    oz.string(),
    ErpIntermediateMetadataSchema.omit({ integrationSource: true }),
  ).optional(),
  autoExportInvoices: oz.boolean(),
  autoExportCreditMemos: oz.boolean(),
  autoExportCustomers: oz.boolean(),
  summarizeLineItemsByProductId: oz.boolean(),
  overrideLineItemQuantity: oz.boolean(),
  linkInvoiceToSalesOrder: oz.boolean(),
  invoiceNumberSyncStrategy: InvoiceNumberSyncStrategySchema.optional(),
  invoicePaymentStatusSyncStrategy: InvoicePaymentStatusSyncStrategySchema.optional(),
  defaultStripeDepositToAccountId: oz.string().nullish(),
});

export type NetSuiteConfigurationFormValues = oz.infer<typeof NetSuiteConfigurationFormSchema>;
export type NetSuiteConfigurationControl = Control<NetSuiteConfigurationFormValues>;
